<template>
  <div class="my-coupon">
    <div class="section-title">我的优惠券</div>

    <!-- 优惠券列表 -->
    <div class="coupon-list">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="未使用" name="unused">
          <empty-component text="暂无可用优惠券哦~"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="已使用/已过期" name="used">
          <empty-component text="暂无已使用或已过期的优惠券~"></empty-component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'MyCoupon',
  components: {
    EmptyComponent
  },
  data() {
    return {
      activeTab: 'unused'
    }
  }
}
</script>

<style lang="scss" scoped>
.my-coupon {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .coupon-list {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;

    :deep(.el-tabs__nav-wrap::after) {
      height: 1px;
    }

    :deep(.el-tabs__active-bar) {
      height: 2px;
    }
  }
}
</style>
